import * as React from 'react'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import { Link } from 'react-router-dom'
import UsersStore from '../../../Stores/UsersStore'
import UserStore from '../../../Stores/UserStore'
import ConfigStore from '../../../Stores/ConfigStore'
import { getUsersTable } from '../../../Model/UsersTableItem'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'
// import matchSorter from 'match-sorter'

export interface IUsersPageProps {
    localizationStore?: LocalizationStore
    usersStore?: UsersStore
    configStore?: ConfigStore
    userStore?: UserStore
}

@inject('localizationStore')
@inject('configStore')
@inject('userStore')
@observer
export default class UsersPage extends React.Component<IUsersPageProps> {

    constructor(props: IUsersPageProps) {
        super(props)

        HttpActionsService.getInstance().getUsers()
    }

    render() {

        const { localizationStore, userStore } = this.props

        return (
            <div className="questionnaires usersTable row page">
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.Users} />
                    {getUsersTable()}
                </div>

                {
                    userStore!.checkAdmin || userStore!.checkSuperAdmin ?
                        <Link className="btn-link" to="/user">{localizationStore!.t('Add user')}</Link> :
                        undefined
                }

                {/* <div className="tip">
                    <em>{ls.t('Tip: Hold shift when sorting to multi-sort!')}</em>
                </div> */}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/UsersPage.tsx